/**
 * Weight pipe
 *
 * @version
 * 4.36.0 OAUI-510 Add / Edit / Remove Attachments
 *
 * @author Ryan Sweeney <rsweeney@buildcentrix.com>
 * @copyright (c) 2022 Build Centrix
 */
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'BcxWeight',
})
export class BcxWeightPipe implements PipeTransform {
  /**
   * Pipe Transform
   * @since 4.36.0
   */
  transform(obj: any): string {
    let unitResult = obj.unit;
    const unitValue = obj.value
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    switch (unitResult) {
      case 'pound':
        unitResult = 'lbs';
        break;
      case 'kilogram':
        unitResult = 'kgs';
        break;
    }
    return [unitValue, unitResult].join(' ');
  }
}
